var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5V8.2C13.5 7.33539 13.1565 6.5062 12.5452 5.89483C11.9338 5.28346 11.1046 4.94 10.24 4.94C9.39 4.94 8.4 5.46 7.92 6.24V5.13H5.13V13.5H7.92V8.57C7.92 7.8 8.54 7.17 9.31 7.17C9.6813 7.17 10.0374 7.3175 10.2999 7.58005C10.5625 7.8426 10.71 8.1987 10.71 8.57V13.5H13.5Z",
    className: "social-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27 13.5V5.13H0.5V13.5H3.27Z",
    className: "social-icon"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88 3.56C2.32556 3.56 2.75288 3.383 3.06794 3.06794C3.383 2.75288 3.56 2.32556 3.56 1.88C3.56 0.95 2.81 0.19 1.88 0.19C1.43178 0.19 1.00193 0.368053 0.684989 0.684989C0.368053 1.00193 0.19 1.43178 0.19 1.88C0.19 2.81 0.95 3.56 1.88 3.56Z",
    className: "social-icon"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.656223bd.svg";
export { ForwardRef as ReactComponent };